// src/context/AuthContext.js
import React, { createContext, useContext, useEffect, useState } from "react";
import { getAccessToken, refreshAccessToken, loginUser, setTokens } from "../api/api";
import { Snackbar, Alert } from "@mui/material";

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);       // 유저 정보 저장
  const [loading, setLoading] = useState(true); // 초기 로딩 상태
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "info" });

  // console.log(user);

  // ✅ 앱 시작 시 토큰 검사 & 로그인 유지
  useEffect(() => {
    const initAuth = async () => {
      const token = getAccessToken();
      if (!token) {
        setLoading(false);
        return;
      }

      // 토큰 유효성 확인 or 갱신
      const newToken = await refreshAccessToken();
      if (newToken) {
        setIsAuthenticated(true);
        // 서버에서 유저정보를 가져올 수 있다면 여기서 fetch
        const storedUser = JSON.parse(localStorage.getItem("user"));
        if (storedUser) setUser(storedUser);
      } else {
        localStorage.clear();
      }
      setLoading(false);
    };
    initAuth();
  }, []);

  // ✅ 로그인 처리
  const handleLogin = async (email, password) => {
    const res = await loginUser(email, password);
    if (res.isLoggedIn) {
      const userData = res.data;
      setUser(userData);
      setIsAuthenticated(true);
      localStorage.setItem("user", JSON.stringify(userData)); // 유저 정보 저장
    }
    return res;
  };

  // ✅ 로그아웃 처리
  const handleLogout = () => {
    setUser(null);
    setIsAuthenticated(false);
    localStorage.clear();
    // 지도 필터·시점 같은 세션 단위 화면 상태도 함께 지운다. 공용 PC 에서
    // 다음 사용자가 이전 사용자의 화면 상태로 시작하지 않게 하기 위함이다.
    sessionStorage.clear();

    // ✅ 로그아웃 안내 메시지
    setSnackbar({ open: true, message: "로그아웃이 완료되었습니다.", severity: "success" });
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  // useEffect(() => {
  //   console.log("🧍 현재 user 상태:", user);
  // }, [user]);
  

  return (
    <AuthContext.Provider
      value={{ user, isAuthenticated, loading, handleLogin, handleLogout }}
    >
      {children}
      {/* ✅ Snackbar 표시 */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000} // 3초 후 자동 닫힘
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
